import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterDrinks',
    standalone: false
})
export class FilterDrinksPipe implements PipeTransform {
  transform(drinks: any[], allowedStatuses: string[]): any[] {
    if (!drinks || !allowedStatuses || allowedStatuses.length === 0) {
      return [];
    }
    return drinks.filter(drink => allowedStatuses.includes(drink.status));
  }
}